<!-- 绑定手机号 -->
<template>
  <a-modal title="绑定手机号" class="login-alert" :maskClosable="false" :visible="visible" :width="450" :confirm-loading="false" :footer="null" @cancel="handleCancel">
    <a-form-model style="margin-top: 20px;" :model="form" :labelCol="{span: 5}" :wrapperCol="{span: 19}" class="m30">
      <a-form-model-item label="手机号">
        <a-input v-model="form.phone" placeholder="邮箱或中国大陆手机号"/>
      </a-form-model-item>
      <a-form-model-item label="密码">
        <a-input-password v-model="form.pwd" placeholder="请输入6-16位密码"/>
      </a-form-model-item>
      <a-form-model-item label="确认密码">
        <a-input-password v-model="form.rePwd" placeholder="请输入确认密码"/>
      </a-form-model-item>
      <a-form-model-item
        label="验证码"
        :extra="msgText"
      >
        <a-row :gutter="8">
          <a-col :span="11">
            <a-input v-model="form.code" placeholder="请输入验证码"/>
          </a-col>
          <a-col :span="9">
            <a-button @click="sendCode" v-bind:disabled="sendCodeDisabled">{{codeText}}</a-button>
          </a-col>
        </a-row>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 19, offset: 5 }">
        <a-button type="primary" html-type="submit" block @click="bindPhone">
          确定
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import store from '@/store'
import matchFun from '@comm/utils/matchFun'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('user')
export default {
  data () {
    return {
      code: '',
      visible: false,
      timeInterval: '',
      form: {
        phone: '',
        code: '',
        smsId: '',
        pwd: '',
        rePwd: ''
      },
      msgText: '绑定邮箱或中国大陆手机号',
      codeText: '发送验证码',
      sendCodeCountdown: 60, // 发送短信间隔
      sendCodeDisabled: false
    }
  },
  methods: {
    ...mapActions(['Logout']),
    show () {
      this.visible = true
    },
    sendCode () {
      if (this.form.phone === '') {
        this.$message.error('请输入邮箱或中国大陆手机号')
        return
      }
      if (!matchFun.phoneFun(this.form.phone) && !matchFun.emailFun(this.form.phone)) {
        this.$message.error('请输入正确的邮箱或中国大陆手机号')
        return
      }
      this.$api.user.smsCode({phone: this.form.phone}).then(res => {
        if (res && res.status === 0) {
          this.sendCodeDisabled = true
          this.msgText = '验证码发送成功'
          this.$message.success(this.msgText)
          this.form.smsId = res.data
          this.timeInterval = setInterval(() => {
            this.sendCodeCountdown--
            this.codeText = this.sendCodeCountdown + ' 秒后重试'
            if (this.sendCodeCountdown <= 0) {
              this.sendCodeDisabled = false
              this.codeText = '发送验证码'
              clearInterval(this.timeInterval)
            }
          }, 1000)
        } else {
          this.$message.error(res.msg)
          this.msgText = res.msg
        }
      }).catch(err => {
        console.log('bind:', err)
      })
    },
    bindPhone () {
      if (this.form.phone === '') {
        this.$message.error('请输入邮箱或中国大陆手机号')
        return
      }
      if (!matchFun.phoneFun(this.form.phone) && !matchFun.emailFun(this.form.phone)) {
        this.$message.error('请输入正确的邮箱或中国大陆手机号')
        return
      }
      if (this.form.pwd === '') {
        this.$message.error('请输入密码')
        return
      }
      if (this.form.pwd.length < 6 || this.form.pwd.length > 16) {
        this.$message.error('密码格式错误')
        return
      }
      if (this.form.pwd !== this.form.rePwd) {
        this.$message.error('两次密码不一致')
        return
      }
      if (this.form.code === '') {
        this.$message.error('请输入验证码')
        return
      }
      this.$api.user.bindPhone({phone: this.form.phone, smsCode: this.form.code, smsId: this.form.smsId, pwd: this.form.pwd}).then(res => {
        if (res && res.status === 0) {
          this.msgText = '绑定成功'
          this.visible = false
          this.getUserData()
        } else {
          this.msgText = res.msg
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('bind:', err)
      })
    },
    getUserData () {
      this.$api.user.userInfo({}).then(info => {
        if (info.status === 0) {
          store.commit('user/USER_CHANGE_USER_INFO', info.data)
          store.commit('user/USER_CHANGE_IS_BIND', 1)
          this.$notification['success']({
            message: '登录成功',
            description: '',
            duration: 4
          })
          window.location.href = store.getters['user/loginUrl']
        }
      })
    },
    handleCancel () {
      const {
        Logout
      } = this
      Logout()
        .then(res => { window.location.href = store.getters['user/loginUrl'] })
        .catch()
        .finally(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.login-alert{
  margin: 24px;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/BindPhone.vue